export default ({ app }) => {
  app.$moment.updateLocale('nl', {
    relativeTime: {
      future: '%s geleden', // normally this would be 'over %s', which means 'in %s'
      past: '%s geleden',
      s: 'een paar seconden',
      m: 'één minuut',
      mm: '%d minuten',
      h: 'één uur',
      hh: '%d uur',
      d: 'één dag',
      dd: '%d dagen',
      M: 'één maand',
      MM: '%d maanden',
      y: 'één jaar',
      yy: '%d jaar'
    }
  })
}
